export const oktaConfig = {
  issuer: process.env.REACT_APP_OKTA_ISSUER || 'https://integrator-6867473.okta.com/oauth2/default',
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID || '0oa14ngmizbmH3oTQ698',
  redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI || `${window.location.origin}/login/callback`,
  postLogoutRedirectUri: window.location.origin,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
};

export const apiConfig = {
  baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:5002',
};
